import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { ProjectCostOverridesEditable } from './components';
import {
  useCostOverrideTableDimensions,
  useProjectCostOverridesData,
  useProjectCostOverridesViewSummary
} from './hooks';

export const ProjectCostOverrides = ({
  editable = false,
  projectSlug,
  projectUri,
  projectCurrency
}) => {
  const {
    viewSummary,
    onViewSummaryClick
  } = useProjectCostOverridesViewSummary();

  const {
    loading: dimensionsLoading,
    projectDimensions
  } = useCostOverrideTableDimensions({ projectId: projectUri });

  const dimensionUris = useMemo(
    () => (projectDimensions || []).map(d => d.id),
    [projectDimensions]
  );

  const {
    loading: ratesLoading,
    projectRates,
    projectRateCount,
    hasMore,
    loadingMore,
    loadMore,
    reloadAll
  } = useProjectCostOverridesData({
    projectId: projectUri,
    dimensionUris,
    skip: dimensionsLoading
  });

  if (ratesLoading || dimensionsLoading) {
    return null;
  }

  const sharedProps = {
    projectSlug,
    projectUri,
    projectCurrency,
    projectRates,
    projectRateCount,
    projectDimensions,
    hasMore,
    loadingMore,
    loadMore,
    reloadAll
  };

  return (
    <>
      <ProjectCostOverridesEditable
        {...sharedProps}
        editable={editable}
        onViewSummaryClick={onViewSummaryClick}
      />
      {viewSummary && (
        <ProjectCostOverridesEditable
          {...sharedProps}
          editable={false}
          edit={viewSummary}
          viewSummary={viewSummary}
          onCancelCallback={onViewSummaryClick}
        />
      )}
    </>
  );
};

ProjectCostOverrides.propTypes = {
  editable: PropTypes.bool,
  projectSlug: PropTypes.string,
  projectUri: PropTypes.string,
  projectCurrency: PropTypes.object
};

export default ProjectCostOverrides;
